import { useSuspenseQuery } from '@tanstack/react-query';

import { DeviceName, MyRobotDTO, ROBOT_MODEL } from 'types/models';

import { MyRobotManager, MyRobotUrls } from './MyRobotManager';
import { useRobotId } from './hooks';
import { useMyRobotPrimaryInformation } from './useMyRobotPrimaryInformation';

/**
 * Deprecated
 * Note: This is an example of how to select values for data that we change often
 * @param select
 */
export function useMyRobot<TData = MyRobotDTO>(select?: (data: MyRobotDTO) => TData) {
  const { robotId } = useRobotId();
  const queryKey = [MyRobotUrls.GetRobotDataConfig.url(robotId)];

  return useSuspenseQuery({
    queryKey,
    queryFn: () => MyRobotManager.GetMyRobot(robotId),
    select,
    notifyOnChangeProps: ['data', 'error'],
  });
}

export function useMyRobotTemplateId() {
  const { data: robotTemplateId } = useMyRobot((data) => data.robotTemplateId);
  return { robotTemplateId };
}

// move to lib
export function useModelName() {
  const { data: modelName } = useMyRobotPrimaryInformation((d) => d.modelName);

  const isSpot = modelName === ROBOT_MODEL.SPOT;
  const isMagni = modelName === ROBOT_MODEL.MAGNI;
  const isTurtleBot = modelName === ROBOT_MODEL.TURTLEBOT;
  const isDrone = modelName === ROBOT_MODEL.DRONE;

  return { isSpot, isMagni, isTurtleBot, modelName, isDrone };
}

/**
 * Todo: Test if we can use ID instead of name for the recoil-family distinguish
 */
export function useDeviceName(): { deviceName: DeviceName } {
  const { data: deviceName } = useMyRobotPrimaryInformation((d) => d.deviceName);

  return { deviceName };
}
